import { BookOpen, Sparkles, Moon } from "lucide-react";
import { Reveal } from "../components/motion";
import { STORY_CATEGORIES } from "../lib/content";

const ART = ["buddy_luna", "buddy_freddy", "buddy_gigi", "buddy_honey", "buddy_poppy", "buddy_hugo", "buddy_narwhal"];
const PASTELS = ["#FBE7EF", "#E4F6E9", "#FFF3D1", "#EEE8FF", "#FBE7EF", "#DFF3FF", "#EEE8FF"];

export default function Stories() {
  return (
    <div data-testid="stories-page" className="bg-cream">
      <section className="px-6 py-20 text-center lg:py-28">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">The story library</p>
          <h1 className="mt-5 font-display text-4xl font-medium leading-tight text-navy sm:text-5xl">
            “Tell me one more story.”
          </h1>
          <p className="mt-4 font-display text-2xl font-medium text-pinkdeep">Now their Buddy can.</p>
          <p className="mx-auto mt-5 max-w-xl text-base text-navy/55">
            Bedtime adventures, fairytales, calming stories and soothing sounds — all told by the friend lying right beside them.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-24">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {STORY_CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 0.08}>
              <div className="group h-full overflow-hidden rounded-[2rem] bg-white shadow-[0_10px_40px_rgba(16,42,86,0.06)]" data-testid={`story-card-${c.name.toLowerCase().replace(/ /g, "-")}`}>
                <div className="h-44 overflow-hidden" style={{ background: PASTELS[i] }}>
                  <img src={`/assets/${ART[i]}.png`} alt={`${c.name} artwork`} loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <BookOpen size={17} style={{ color: c.color }} />
                  <h2 className="mt-3 font-display text-xl font-semibold text-navy">{c.name}</h2>
                  <p className="mt-1.5 text-sm text-navy/55">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-lavender px-6 py-24">
        <Reveal className="mx-auto max-w-3xl text-center">
          <Moon className="mx-auto text-pink" size={30} />
          <span className="mt-5 inline-flex rounded-full bg-moon px-4 py-1.5 font-display text-xs font-semibold text-navy" data-testid="personalized-badge">
            PERSONALIZED STORIES — COMING SOON
          </span>
          <h2 className="mt-6 font-display text-3xl font-medium text-navy sm:text-4xl">Imagine your child becoming part of the story.</h2>
          <div className="mt-8 rounded-[2rem] bg-white p-8 text-left shadow-[0_10px_40px_rgba(16,42,86,0.06)]">
            <Sparkles className="text-lavdeep" size={20} />
            <p className="mt-4 font-display text-lg italic leading-relaxed text-navy/70">
              “Tonight, Luna and Halo discovered a secret castle hidden above the clouds. The door only opened for friends who knew the special knock — and luckily, Halo knew exactly what it was…”
            </p>
          </div>
          <p className="mt-6 text-sm text-navy/50">Join the family to be first in line when personalized stories launch.</p>
        </Reveal>
      </section>
    </div>
  );
}
